module.exports = __webpack_public_path__ + "quilombinho.jpg?a42104e4073816c59fa3f2bb4968bfa8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/quilombinho.jpg
// module id = 150
// module chunks = 0